/* unplugin-vue-components disabled */import { render } from "./ShopTypeSettingView.vue?vue&type=template&id=133ab163&scoped=true"
import script from "./ShopTypeSettingView.vue?vue&type=script&lang=js"
export * from "./ShopTypeSettingView.vue?vue&type=script&lang=js"

import "./ShopTypeSettingView.vue?vue&type=style&index=0&id=133ab163&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133ab163"]])

export default __exports__